const LiquifyHelper = {
    /**
     * Format a monetary value with the currency-format set in Shopify backend.
     *
     * @int value
     * @bool minor Optional, defaults to true.
     * @string shopMoneyFormat Shop-Setting, via Liquid: shop.money_with_currency_format
     */
    moneyFormat: (value, isMinor = true, shopMoneyFormat = '') => {
        let floatValue = parseFloat(value);

        if (isNaN(floatValue)) {
            return '';
        }

        floatValue = isMinor
            ? floatValue / 100
            : floatValue;

        let formattedValue = '';
        const match = shopMoneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        const formatType = match ? match[1] : null;

        switch (formatType) {
            case 'amount':
                formattedValue = floatValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                break;
            case 'amount_no_decimals':
                formattedValue = Math.round(floatValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                break;
            case 'amount_with_comma_separator':
                formattedValue = floatValue.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                break;
            default:
                console.log('Error in moneyFormat. Unknown format type or none provided: ' + formatType);

                const formatter = new Intl.NumberFormat(Shopify.locale + '-' + Shopify.country, {
                    style: 'currency',
                    currency: Shopify.currency.active,
                });

                value = isMinor ? value / 100 : value;

                return formatter.format(value);
        }

        return shopMoneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, formattedValue);
    },

    htmlspecialchars_decode(string) {
        let tempElement = document.createElement('textarea');
        tempElement.innerHTML = string;
        return tempElement.value;
    },

    triggerClick: function (el) {
        if(!(el instanceof HTMLElement)) {
            console.info(el + ' must be an instance of HTMLElement')
            return
        }
        const ev = new KeyboardEvent("keydown",{
            code: 'Enter',
            key: 'Enter',
            charCode: 13,
            keyCode: 13,
            view: window,
            bubbles: true
        });

        el.dispatchEvent(ev);
    },

    /**
     * Trigger dropdown click to open minicart
     */
    handleTriggerClick: function () {
      const path = window.location.pathname;
    if (path.includes('/en/') || path === '/en') {
        const dictionary = {
          // Product labels
          "Lebensmittelangaben": "Food information",
          "Inkl. 19% MwSt., zzgl. Versandkosten": "incl. 19% sales tax, excl. shipping",
          "Leicht": "Light",
          "Schwer": "Heavy",
          "Trocken": "Dry",
          "Ausverkauft": "Sold Out",
          "Süss": "Sweet",
          "Nachhaltig": "Sustainable",
          "Neu": "New",
          "Spare": "Save",
          "statt": "instead of",
          "In den Warenkorb": "Add to cart",

          // Newsletter block
          "Abonniere unseren Newsletter und spare 5€ auf deine erste Bestellung.": "Sign up to our newsletter and save 5€ on your first order.",
          "Deine E-Mail Adressa": "Your E-Mail",
          "Dein Vorname": "Your first name",
          "Jetzt 5€ sparen": "Save 5€ now",
          "Im Anschluss erhältst Du eine E-Mail von uns mit einem Link, um Deine Anmeldung zum Newsletter zu bestätigen": "You'll receive a E-Mail from us with a link to confirm your subscription to the newsletter",
          "(Bitte prüfe auch deinen SPAM-Ordner)": "(Please check your SPAM folder as well)",
          "Der Newsletter kann jederzeit kostenlos abbestellt werden.": "You can cancel your subscription any time for free.",

          // Product card (home page) block
          "Anzahl wählen": "Choose amount",
          "Flasche": "Bottle",
          "Karton": "Box",
          "Flaschen": "Bottles",
          "Preis pro Ltr.": "Price per Ltr.",
          "Lebensmittelangaben. Inkl. 19% MwSt, zzgl. Versandkosten": "Food information, incl. 19% sales tax, excl. shipping",
          "Direkt lieferbar": "Ready to ship",

          // Product details block
          "Rebsorte": "Variety",
          "Weingut": "Wineyard",
          "Ort": "Location",
          "Land": "Country",
          "Region": "Region",
          "Alkoholgehalt": "Alcohol",
          "Nachhaltigkeit": "Sustainability",
          "Allergene": "Allergens",
          "Trinktemperatur": "Drinking temperature",
          "Ernte": "Harvesting method",
          "Verschluss": "Closure",

          // Profile details block – note "Weingut" appears again.
          "Steckbrief": "Profile",
          "Beschreibung": "Description",
          "Weingut": "Wineyard",  // This overwrites the previous "Weingut" value.
          "Weitre Wine": "More wines",

          // Cart block (product cart)
          "Mein Warenkorb": "My cart",
          "Einzelpreis": "Price per bottle",
          "Entfernen": "Remove",
          "Gratisversand freigeschaltet": "Free shipping unlocked",
          "Glückwunsch! Du hast den Gratisversand auf deine Bestellung freigeschaltet.": "Congrats! You've just unlocked free shipping on your order.",

          // Cart overview block
          "Ihr Warenkorb": "Your cart",
          "Produkt": "Product",
          "Anzahl": "Quantity",
          "Preis": "Price",
          "Kosten": "Cost",
          "Gesamtsumme (inkl. MwSt.)": "Sum (tax incl.)",
          "Zur Kasse": "Checkout",
          "Warenkorb aktualisieren": "Update cart",
          "Kommentarfeld": "Comment",
          "Dein Platz für spezielle Versandhinweise und handschriftliche Grußworte für Geschenke": "Your place for special order notes and handwritten greetings for gifts",

          // Greeting block
          "Hallo": "Hello",
          "Schön, dass du da bist.": "Nice to see you.",

          // Account / Customer area (first variant)
          "Account": "Account",
          "Adressen": "Adress",
          "Merkliste": "Watch list",
          "Letzte Bestellungen": "Previous orders",
          "Bisher wurden keine Bestellungen aufgegeben": "No orders yet",
          "Jetzt Shoppen": "Shop now",
          "Kundendaten": "Customer data",
          "Adresse hinzufügen": "Add adress",

          // Account / Customer area (second variant – already in English but added for completeness)
          "Adress": "Adress",
          "Watch list": "Watch list",
          "Previous orders": "Previous orders",
          "No orders yet": "No orders yet",
          "Shop now": "Shop now",
          "Customer data": "Customer data",
          "Add adress": "Add adress",
          "Preis pro Ltr": "Price per Ltr",
          "In den Warenkorb": "Add to cart",
          "Weitere Weine": "More wines",
          "Einzelpreis": "unit price",
          "Entfernen": "Remove",
          "Glückwunsch! Du hast den Gratisversand auf Deine Bestellung freigeschaltet": "Congrats! You've just unlocked free shipping with DPD for your order",
          "Gesamtbetrag": "Total amount",
          "Warenkorb": "Cart",
          "Jetzt Gratisversand sichern.": "Get free shipping",

          "und wir übernehmen Deine Versandkosten": "left to get free shipping",
          "Hallo": "Hello",
          "Schön, dass du da bist": "Nice to see you",
          "Bestellungen": "Order",
          "Adressen bearbeiten": "Change adress",
          "Abmelden": "Log out",
          "Zum Warenkorb": "Cart",
          "Unser Sortiment": "Our assortment",
          "Weinkiste": "Wine box",
          "Roséwein": "rose wine",
          "Abonniere unseren Newsletter und spare 5€ auf Deine erste Bestellung": "Sign up for our newsletter and get a 5€ discount off your first order",
          "Deine E-Mail Adresse": "Your E-Mail",
          "Dein Vorname": "Your first name",
          "Jetzt 5€ sparen": "Save 5€ now",
          "m Anschluss erhältst Du eine E-Mail von uns mit einem Link, um Deine Anmeldung zum Newsletter zu bestätigen.": "Right after your signup we will send you an e-mail with a link to confirm your newsletter subscription",
          "(Bitte prüfe auch Deinen SPAM-Ordner)": "(check your spam, in case it's not in your inbox)",
          "Der Newsletter kann jederzeit kostenlos abbestellt werden.": "You can unsubscribe from our newsletter at any given time free of charge.",
          "Probierpakete": "mixed cases",
          "Probierpaket": "mixed case",
          "Nur beste Weine.": "Best wines only.",
          "Vioneers x Gastronomie": "Vioneers x gastronomy",
          "Nur beste Winzer.": "Best winemakers only.",
          "Nur beste Qualität.": "Best quality only.",
          "Nur bester Geschmack.": "Best taste only.",
          "NES": "SHS",
          "Gastronomie": "gastronomy",
          "Generelle Anfrage": "General inquiry",
          "Veranstaltungen": "Events",
          "Anfahrt": "How to get here",
          "Einloggen": "Login",
          "Schön, dass Du da bist": "Nice to see you",
          "Guten Tag,": "Hello ",
  "Noch nicht registriert?": "Not registered yet?",
  "Jetzt registrieren": "Register now",
          "Passwort vergessen?": "Forgot your password?",
          "Jetzt zurücksetzen": "Reset it now",
          "Noch": "Only",
          "Keine Artikel im Cart": "No items in the cart"
        };

      // Sort dictionary keys by length (descending) so longer strings are replaced first.
      const keysSorted = Object.keys(dictionary).sort((a, b) => b.length - a.length);

      // Helper function to translate a given text using the dictionary.
      function translateText(text) {
        for (const key of keysSorted) {
          // Escape special characters in the German phrase.
          const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const regex = new RegExp(escapedKey, 'g');
          text = text.replace(regex, dictionary[key]);
        }
        return text;
      }

      // Helper function to recursively traverse the DOM and replace text nodes and placeholders.
      function traverseNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.nodeValue = translateText(node.nodeValue);
        } else if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.tagName !== 'SCRIPT' &&
          node.tagName !== 'STYLE'
        ) {
          // Translate the placeholder attribute if it exists.
          if (node.hasAttribute('placeholder')) {
            const originalPlaceholder = node.getAttribute('placeholder');
            node.setAttribute('placeholder', translateText(originalPlaceholder));
          }
          // Optionally, add similar logic for other attributes like "title" if needed.
          node.childNodes.forEach(child => traverseNodes(child));
        }
      }

      // Function to perform the translation.
      function translatePage() {
        traverseNodes(document.body);
        document.querySelector(".kl-private-reset-css-Xuajs1 > div:nth-child(1) > span > span:nth-child(1)").innerText = document.querySelector(".kl-private-reset-css-Xuajs1 > div:nth-child(1) > span > span:nth-child(1)").innerText.replace("I","");
      }

      // Execute translation on page load.
      translatePage();
      // Execute again after 2 seconds to catch dynamically added content.
      setTimeout(translatePage, 1000);
      setTimeout(translatePage, 2000);
      setTimeout(translatePage, 3000);
    }
        let elements = document.querySelectorAll('[li-element="mini-cart-toggle"]');
        elements.forEach(element => {
            let closestDropdown = element.closest('.w-dropdown-toggle');
            if (closestDropdown) {
                this.triggerClick(closestDropdown);
            } else {
                console.error('(helper.js) No dropdown found for minicart trigger');
            }
        });
    },

    triggerClickById: (id) => {
        const el = document.getElementById(id)
        LiquifyHelper.triggerClick(el)
    },

    triggerClickByClass: (className) => {
        const elList = document.getElementsByClassName(className)
        for (const el of elList) {
            LiquifyHelper.triggerClick(el)
        }
    },
};
